export const getPromos = () => ({
  url: 'me/promotions',
})
